var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"popover",class:{ 'popover-disabled': _vm.disabled },attrs:{"data-delay":_vm.delayObjectStr},on:{"click":function($event){return _vm.dismiss()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }